import { combineReducers } from 'redux';

import downloadReducer from './store/downloadReducer';

export const reducers = combineReducers({
    download: downloadReducer,

});